import React, { useEffect, useState } from 'react'
import {
  Backdrop,
  Fade,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  makeStyles,
  Modal,
  Paper,
  Typography,
} from '@material-ui/core'
import { Close as CloseIcon } from '@material-ui/icons'
import { useTranslation } from 'react-i18next'
//import { useStoreActions, useStoreState } from '../../store/store.hooks'
//import { useForm } from 'react-hook-form'
import logo from '@/assets/img/doki-logo-white.png'
import computerImage from '@/assets/img/guideline_tutorial/4.png'
import laptopImage from '@/assets/img/guideline_tutorial/laptop.png'
import chromeImage from '@/assets/img/guideline_tutorial/chrome.png'
import videoCallImage from '@/assets/img/guideline_tutorial/5.png'

const useStyles = makeStyles((theme) => ({
  computerImage: {
    width: 150,
    height: 'auto',
    marginTop: '1rem',
  },

  closeButton: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
    color: 'white',
  },

  emphasis: {
    padding: '2rem',
    boxShadow: 'none',
    textAlign: 'center',
    color: 'white',
    background: 'none',

    [theme.breakpoints.down('xs')]: {
      padding: 0,
    },
  },

  emphasisGrid: {
    marginLeft: '1rem',

    [theme.breakpoints.down('xs')]: {
      marginLeft: 0,
    },
  },

  grid: {
    display: 'flex',
    flexDirection: 'row',
  },

  importantInfo: {
    color: 'white',
    fontSize: '1.25rem',
    textTransform: 'uppercase',
    fontWeight: 'bold',
  },

  listContainer: {
    maxWidth: 400,
    margin: '0 auto',
  },

  listIcon: {
    width: '36px',
  },

  logo: {
    width: '12rem',
    height: 'auto',
  },

  modal: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',

    '& :focus-visible': {
      outline: 'none',
      border: 'none',
    },
  },

  paper: {
    position: 'relative',
    boxShadow: theme.shadows[5],
    padding: '1rem',
    borderRadius: 8,
    maxWidth: 700,
    background: 'linear-gradient(45deg, #3FA7F0 0%, #F01E5A 100%)',
    color: '#fff',
  },

  scrollableModal: {
    maxWidth: 600,
    width: '100%',
    borderRadius: 8,
    padding: '0.25rem',
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    overflowY: 'auto',
    maxHeight: '90vh',
  },

  scrollableModalWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    padding: '0.25rem',
    boxSizing: 'border-box',
  },

  toAvoid: {
    fontWeight: 'bold',
    fontSize: '1.25rem',
    marginTop: '2rem',
  },

  warning: {
    fontSize: '1rem',
    marginTop: '1rem',
  },
}))

const TechnicalDifficultiesPopup = ({ open }) => {
  const classes = useStyles()
  const { t } = useTranslation('popups')
  const [isOpen, setIsOpen] = useState(true)

  useEffect(() => {
    setIsOpen(open)
  }, [open])

  const handleClose = () => {
    setIsOpen(false)

    sessionStorage.setItem('shownTechnicalDifficultiesPopup', 'true')
  }

  if (!isOpen) {
    return null
  }

  return (
    <>
      <Modal
        open={isOpen}
        onClose={handleClose}
        className={classes.modal}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 30 }}
      >
        <div className={classes.scrollableModalWrapper}>
          <div className={classes.scrollableModal}>
            <Fade in={isOpen}>
              <Paper className={classes.paper}>
                <IconButton
                  className={classes.closeButton}
                  onClick={handleClose}
                >
                  <CloseIcon />
                </IconButton>
                <Grid container xs={12} spacing={3} className={classes.grid}>
                  <Grid item container xs={12} justifyContent="center">
                    <img src={logo} alt="DokiApp" className={classes.logo} />
                  </Grid>

                  <Grid item container xs={12} className={classes.emphasisGrid}>
                    <Paper className={classes.emphasis}>
                      <Typography className={classes.importantInfo}>
                        {t('importantInfo')}
                      </Typography>
                      <Typography
                        className={classes.warning}
                        dangerouslySetInnerHTML={{
                          __html: t('warning'),
                        }}
                      ></Typography>
                      <img
                        src={computerImage}
                        alt="DokiApp"
                        className={classes.computerImage}
                      />
                      <Typography className={classes.toAvoid}>
                        {t('toAvoid')}
                      </Typography>

                      <div className={classes.listContainer}>
                        <List>
                          <ListItem>
                            <ListItemIcon>
                              <img
                                src={laptopImage}
                                className={classes.listIcon}
                                alt="laptop"
                              />
                            </ListItemIcon>
                            <ListItemText>
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: t('first'),
                                }}
                              ></span>
                            </ListItemText>
                          </ListItem>

                          <ListItem>
                            <ListItemIcon>
                              <img
                                src={chromeImage}
                                className={classes.listIcon}
                                alt="Chrome"
                              />
                            </ListItemIcon>
                            <ListItemText primary={t('second')} />
                          </ListItem>

                          <ListItem>
                            <ListItemIcon>
                              <img
                                src={videoCallImage}
                                className={classes.listIcon}
                                alt="video"
                              />
                            </ListItemIcon>
                            <ListItemText primary={t('third')} />
                          </ListItem>
                        </List>
                      </div>
                    </Paper>
                  </Grid>
                </Grid>
              </Paper>
            </Fade>
          </div>
        </div>
      </Modal>
    </>
  )
}

TechnicalDifficultiesPopup.displayName = 'TechnicalDifficultiesPopup'
export { TechnicalDifficultiesPopup }
export default TechnicalDifficultiesPopup
